import { CategorySelect } from '~/pages/categories/components/category-select';
import { DistrictSelect } from '~/pages/district/components/district-select';
import { SexFilterSelect } from '~/pages/sex/components/sex-filter-select';
import { getDefaultAgeCategoryId, querySchema, SimpleCompetitionTypeToIdMap } from './query-schema';
import { useFilterForm } from '~/hooks/useFilterForm';
import { Grid } from '~/components/Grid/Grid';
import { Input } from '~/components/Input';
import { ChangeEvent } from 'react';

export function RecordListFilter() {
  const { setValues, setValue, values } = useFilterForm(querySchema.parse);

  function handleCompetitionTypeChange(event: ChangeEvent<HTMLSelectElement>) {
    setValues({ competition_type: event.target.value, age_category_id: undefined });
  }

  function handleAgeCategoryChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('age_category_id', event.target.value);
  }

  function handleDistrictChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('district_id', event.target.value);
  }

  function handleSexChange(event: ChangeEvent<HTMLSelectElement>) {
    setValue('sex', event.target.value);
  }

  return (
    <div
      style={{
        borderBottom: '2px solid var(--color-fg-secondary)',
        paddingBottom: 'var(--size-4)',
        marginBottom: 'var(--size-4)',
      }}
    >
      <Grid>
        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <Input.Select
            defaultValue={values.competition_type}
            onChange={handleCompetitionTypeChange}
            aria-label="Tävlingstyp"
            options={[
              ['Klassisk', 'classic'],
              ['Utrustad', 'equipped'],
              ['IFN', 'ifn'],
              ['Para', 'para'],
            ]}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <CategorySelect
            query={{ competition_types: SimpleCompetitionTypeToIdMap[values.competition_type], has_records: true }}
            defaultValue={values.age_category_id ?? getDefaultAgeCategoryId(values.competition_type)}
            onChange={handleAgeCategoryChange}
            placeholder={undefined}
          />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <SexFilterSelect onChange={event => handleSexChange(event)} defaultValue={values.sex} disableAllOption />
        </Grid.Item>

        <Grid.Item cols={{ sm: 6, md: 3 }}>
          <DistrictSelect
            onChange={event => handleDistrictChange(event)}
            defaultValue={values.district_id}
            placeholder="Svenska Rekord"
          />
        </Grid.Item>
      </Grid>
    </div>
  );
}
